'use strict';

var _ = require('lodash');

module.exports = {
  getIcon: function (options, tags) {
    
    options = _.extend({
      size: 's',
      color: '#858F93',
      iconColor: '#1A1919'
    }, options);

    if (isRouteStart(tags) || isRouteEnd(tags)) {
      options.markerShape = 'square';
      options.color = '#87B049';
      options.border = '1px solid #333';
    }

    // need to offset the marker... routeStart goes up and routeEnd down
    if (!isStart(tags) && isRouteStart(tags)) {
      options.offset = [0, -7];
    }

    if (!isEnd(tags) && isRouteEnd(tags)) {
      options.offset = [0, 8];
    }

    function isStart (tags) {
      if (tags) {
        return tags.split(/,\s?/).indexOf('start') !== -1;
      }
      
      return false;
    }

    function isRouteStart (tags) {
      if (tags) {
        return tags.split(/,\s?/).indexOf('routeStart') !== -1;
      }

      return false;
    }

    function isEnd (tags) {
      if (tags) {
        return tags.split(/,\s?/).indexOf('end') !== -1;
      }

      return false;
    }

    function isRouteEnd (tags) {
      if (tags) {
        return tags.split(/,\s?/).indexOf('routeEnd') !== -1;
      }

      return false;
    }

    return L.ShapeMarker.icon(options);
  },

  getLabelIcon: function (options) {
    var html = [
      '<span class="content">', 
        options.text,
      '</span>'
    ].join('');

    options = _.defaults({
      html: html,
      iconSize: [54, 20],
      className: ''
    }, options);

    // needs to ALWAYS have the `route-label` className
    if (options.className.indexOf('route-label') === -1) {
      options.className = options.className && 'route-label ' + options.className || 'route-label';
    }

    return L.divIcon(options);
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/route/lib/MarkerUtil.js